import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BACKEND_URL } from '../Enums/GameEnums';
export const apiSlice = createApi({
  reducerPath: 'apiSlice',
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
  }),
  tagTypes: ['data'],
  endpoints: (builder) => ({
    getStats: builder.query({
      query: () => '/data',
      providesTags: ['data'],
    }),
    postStats: builder.mutation({
      query: (payload) => ({
        url: '/data',
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      invalidatesTags: ['data'],
    }),
  }),
})

export const apiActions = apiSlice.endpoints;

export const { useGetStatsQuery, usePostStatsMutation } = apiSlice